var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.057 24.353c0-1.315-.106-2.275-.335-3.27H23.845v5.937h8.733c-.176 1.475-1.127 3.697-3.24 5.19l-.03.199 4.705 3.679.326.033c2.992-2.791 4.718-6.897 4.718-11.768z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.845 39.996c4.278 0 7.87-1.422 10.493-3.875l-5-3.911c-1.338.942-3.134 1.6-5.493 1.6-4.19 0-7.746-2.79-9.014-6.648l-.186.016L9.754 31l-.064.18c2.606 5.225 7.958 8.816 14.155 8.816z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.831 27.162a9.935 9.935 0 0 1-.528-3.164c0-1.102.193-2.169.51-3.164l-.008-.212-4.953-3.883-.162.078A16.139 16.139 0 0 0 8 23.997c0 2.578.616 5.014 1.69 7.182l5.141-4.017z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.845 14.186c2.975 0 4.983 1.297 6.127 2.382l4.472-4.409C31.697 9.582 28.124 8 23.845 8c-6.197 0-11.55 3.59-14.155 8.817l5.123 4.017c1.286-3.857 4.842-6.648 9.032-6.648z",
    fill: "#EB4335"
  })));
};
export default SvgGoogle;